export default {
    action_load_search: 'ajax_load_search',
    search_is_loading: false,

    init() {
        let context = this;

        $('.js-mobile-search').on('click', function() {
            $('#search-form__field').val('').focus();
            $('.global_search-modal').addClass('block');
        })

        /* SEARCH MODAL */
        $('.js-search-submit').on('click', $.proxy(this.load_search, this));
        $('.js-search-field').on('keyup', function(e) {

            if($(this).val() == '') {
                $('.js-search-clear').hide();
            } else {
                $('.js-search-clear').show();
            }
            if (e.keyCode === 13) {
                context.load_search();
            }
        });

        $('.js-search_icon').on('click', function() {
            context.load_search();
        });

        /* Clear Search Input Field */
        $('.js-search-clear').click(function() {
            $(this).hide();
            $('#search-form__field').val('');
            $('.js-search-modal-results').hide().empty();
        });

    },


    load_search() {
        this.show_loader(true);

        let context = this;
        let search_val = $('.js-search-field').val();
        let content_container = $('.js-search-modal-results');
        content_container.hide().empty();

        let data = {
            action: this.action_load_search,
            search_term: search_val,
        };

        // eslint-disable-next-line no-undef
        $.get(freybe.ajax_url, data, $.proxy(function(html) {
            if (html === '') {
                console.log('do nothing');
            } else {
                content_container.show().append(html);
                context.add_search_filter_listeners();
            }

            this.show_loader(false);

        }, this));

    },
    show_loader(show) { // sets loading boolean and handles show/hide of loader animation
        this.search_is_loading = show;
        let loader_el = $('.js-search-loader');
        show ? $(loader_el).addClass('ajax-loader--active') : $(loader_el).removeClass('ajax-loader--active');
    },
    add_search_filter_listeners() {
        $('.search-filters .button').on('click', $.proxy(this.filter_search, this));
    },
    filter_search(e) {
        let target_section = '.' + e.currentTarget.getAttribute('data-target');
        $('.js-search-results').hide(); // hide all results
        $(target_section).show(); // show the target results
        $('.search-filters .button').removeClass('button--active');
        $(e.currentTarget).addClass('button--active');
    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
    },
};